import debounce from 'lodash/debounce'
import { ValidationError } from '@/services/errors'
import { ToastProgrammatic as Toast } from 'buefy'
import { workOrderItem } from '@/services/WorkOrders/UpdateWorkOrder/store'
import { hoaUtility } from '@/services/Hoa/store'
import { workOrderList } from '@/services/WorkOrders/store'
import moment from 'moment'
import $ from 'jquery'
const today = moment()

function notifyError(e) {
  Toast.open({
    duration: 7000,
    message: e.message || e,
    position: 'is-bottom',
    type: 'is-danger'
  })
}

var DEFAULT_FORM_VALUES = {
  workOrderID: 0,
  completeByDate: null,
  sentToVendorDate: null,
  completedDate: null,
  cancelledDate: null,
  workOrderTypeID: 0,
  locationDescription: '',
  specialInstructions: '',
  completedNote: '',
  locationType: '',
  latitude: 0,
  longitude: 0,
  description: '',
  detailedDescription: '',
  cancelledReason: ''
}

export const methods = {
  toggleFilters: function() {
    this.filters.show = !this.filters.show
  },

  async reloadParentImages() {
    if (this.isDebug === true) console.debug('reloadParentImages...')
  },

  async processWorkOrderUpdate(workOrder) {
    if (!workOrder || workOrder == undefined) {
      notifyError('Could not update the work order at this time.')
      return
    }

    await workOrderItem.dispatch('updateWorkOrder', {
      payload: workOrder,
      done: () => {
        this.loading = false
        this.reload()
      }
    })
  },

  async reload() {
    this.loading = true

    this.workOrderID = this.$route.params.id

    await workOrderList
      .dispatch('getAccessToken', {
        credentialsName: 'google-maps-api-key'
      })
      .then(({ result }) => {
        if (result) {
          this.accessToken = result.credentialValue
        }
      })

    if (this.isDebug == true) console.debug('workOrderID=' + this.workOrderID)

    this.formData = { ...DEFAULT_FORM_VALUES }

    this.populateLocationTypes()

    await hoaUtility
      .dispatch('loadDropDownAddressList', {
        hoaID: this.hoaId
      })
      .then(({ list }) => {
        if (list) {
          this.addressDropDownList = list
        }
        if (this.addressDropDownList && this.addressDropDownList != undefined) {
          if (this.isDebug == true)
            console.debug('addressDropDownList=' + JSON.stringify(this.addressDropDownList))

          this.addressData = this.addressDropDownList
        }
      })

    await hoaUtility
      .dispatch('loadVendors', {
        hoaID: this.hoaId
      })
      .then(({ list }) => {
        if (list) {
          this.vendorDropDownList = list
        }
        if (this.vendorDropDownList && this.vendorDropDownList != undefined) {
          if (this.isDebug == true)
            console.debug('vendorDropDownList=' + JSON.stringify(this.vendorDropDownList))

          this.vendorData = this.vendorDropDownList
        }
      })

    await workOrderItem
      .dispatch('getWorkOrderTypeList', {
        hoaID: this.hoaId
      })
      .then(({ list }) => {
        if (list) {
          this.workOrderTypeList = list
        }
      })

    this.formData.latitude = 0
    this.formData.longitude = 0

    try {
      await workOrderItem
        .dispatch('getWorkOrderById', {
          workOrderID: this.workOrderID
        })
        .then(async ({ workorder }) => {
          if (this.isDebug == true) console.debug('workOrder=' + JSON.stringify(workorder))

          if (workorder) {
            this.workOrder = workorder
          }

          if (this.workOrderID && this.workOrder && this.workOrder != undefined) {
            this.formData.workOrderTypeID = this.workOrder.workOrderTypeID
              ? this.workOrder.workOrderTypeID
              : 0
            this.formData.locationDescription = this.workOrder.locationDescription
              ? this.workOrder.locationDescription
              : ''
            this.formData.cancelledReason = this.workOrder.cancelledReason
            this.formData.description = this.workOrder.description
            this.formData.detailedDescription = this.workOrder.detailedDescription
            this.formData.locationDescription = this.workOrder.locationDescription
              ? this.workOrder.locationDescription
              : ''
            this.formData.specialInstructions = this.workOrder.specialInstructions
              ? this.workOrder.specialInstructions
              : ''
            this.formData.completedNote = this.workOrder.completionNote
              ? this.workOrder.completionNote
              : ''

            this.formData.completeByDate =
              this.workOrder.completeByDate != null ? new Date(this.workOrder.completeByDate) : null
            this.formData.sentToVendorDate =
              this.workOrder.sentToVendorDate != null
                ? new Date(this.workOrder.sentToVendorDate)
                : null
            this.formData.completedDate =
              this.workOrder.completionDate != null ? new Date(this.workOrder.completionDate) : null

            this.formData.cancelledDate =
              this.workOrder.cancelledDate != null ? new Date(this.workOrder.cancelledDate) : null

            if (
              this.workOrder.unit !== undefined &&
              this.workOrder.unit.address !== undefined &&
              this.workOrder.unit &&
              this.workOrder.unit.address
            ) {
              const address1 = this.workOrder.unit.address.addressOne
              const address2 = this.workOrder.unit.address.addressTwo
              const addressCity = this.workOrder.unit.address.city
              const addressState = this.workOrder.unit.address.state
              const addressPostal = this.workOrder.unit.address.postalCode

              const fullAddress = `${address1 ? address1 + ', ' : ''}${address2 ? address2 : ''}${
                addressCity ? addressCity : ''
              } ${addressState ? addressState : ''}  ${addressPostal ? addressPostal : ''}`

              this.addressFilterQuery = fullAddress ? fullAddress : ''
            }

            this.vendorFilterQuery = this.workOrder.vendor.name ? this.workOrder.vendor.name : ''

            this.formData.locationType = this.workOrder.locationType
              ? this.workOrder.locationType
              : null
            this.formData.latitude =
              this.workOrder.latitude && this.workOrder.latitude !== 0 ? this.workOrder.latitude : 0
            this.formData.longitude =
              this.workOrder.longitude && this.workOrder.longitude !== 0
                ? this.workOrder.longitude
                : 0

            if (this.formData.latitude === 0) {
              await this.loadHoaBoundsCoords()
              this.formData.latitude = this.defaultCenterLat
              this.formData.longitude = this.defaultCenterLng
            }
          }
        })
    } catch (e) {
      console.debug('error while loading reload work order update method:' + e)
    }

    this.loading = false
  },

  async loadHoaBoundsCoords() {
    await hoaUtility
      .dispatch('getHoaById', {
        hoaID: this.hoaId
      })
      .then(({ result }) => {
        if (
          result &&
          result.northmostLatitude &&
          result.southmostLatitude &&
          result.eastmostLongitude &&
          result.westmostLongitude
        ) {
          this.defaultCenterLat = (result.northmostLatitude + result.southmostLatitude) / 2
          this.defaultCenterLng = (result.eastmostLongitude + result.westmostLongitude) / 2
        }
      })
  },

  async populateLocationTypes() {
    await workOrderList.dispatch('loadLocationTypesManagement').then(({ list }) => {
      if (list) {
        this.locationTypeList = list
        this.locationType = '<-Select a Location Type->'
      }
    })
  },

  returnToParent() {
    this.$router.push({
      name: 'workOrders'
    })
  },

  completeWorkOrder() {
    this.currentWorkOrder = this.workOrder
    this.completeToggle = true
  },

  confirmResetCompletedToIncomplete() {
    this.$buefy.dialog.confirm({
      title: 'Reset Work Order',
      message: `Are you sure you want to <b>Reset</b> this work order's completion to incomplete?`,
      confirmText: 'Reset Work Order',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: () => {
        this.resetWorkOrder()
      }
    })
  },

  resetWorkOrder() {
    console.debug('resetWorkOrder...')
    this.onFormSubmit(true)
  },

  locationTypeChanged() {
    if (this.locationType === 'Common Area') {
      console.debug('blur locationTypeChanged' + this.locationType)
      this.hideShowMapFlag = true

      if (this.hideShowMapFlag == true) {
        this.hideShowMapText = 'Hide Map'
        this.locationTypeText = 'Location Type - Place marker on map'
      }
    } else {
      this.hideShowMapFlag = false

      if (this.hideShowMapFlag == false) {
        this.hideShowMapText = 'Show Map'
        this.locationTypeText = 'Location Type'
      }
    }
  },

  hideShowMap() {
    console.debug('in hideShowMap...')
    this.hideShowMapFlag = !this.hideShowMapFlag

    if (this.hideShowMapFlag == true) {
      this.hideShowMapText = 'Hide Map'
    } else {
      this.hideShowMapText = 'Show Map'
    }
  },

  getPayload(resetWorkOrder) {
    let address = []
    if (
      this.addressDropDownList &&
      this.addressDropDownList !== undefined &&
      this.addressDropDownList.length > 0
    ) {
      address = this.addressDropDownList.filter(i => i.label.includes(this.addressFilterQuery))
    }

    let vendor = []
    if (
      this.vendorDropDownList &&
      this.vendorDropDownList !== undefined &&
      this.vendorDropDownList.length > 0
    ) {
      vendor = this.vendorDropDownList.filter(i => i.label.includes(this.vendorFilterQuery))
    }

    const payload = {
      workOrderID: this.workOrderID,
      workOrderTypeID:
        this.formData.workOrderTypeID && this.formData.workOrderTypeID != undefined
          ? this.formData.workOrderTypeID
          : 0,
      vendorID: vendor && vendor[0] && vendor[0].value ? vendor[0].value : 0,
      hoaID: this.workOrder.hoaID,
      unitID: address && address[0] && address[0].unitID ? address[0].unitID : 0,
      locationDescription:
        this.formData.locationDescription && this.formData.locationDescription != undefined
          ? this.formData.locationDescription
          : '',
      description:
        this.formData.description && this.formData.description != undefined
          ? this.formData.description
          : '',
      detailedDescription:
        this.formData.detailedDescription && this.formData.detailedDescription !== undefined
          ? this.formData.detailedDescription
          : '',
      specialInstructions:
        this.formData.specialInstructions && this.formData.specialInstructions != undefined
          ? this.formData.specialInstructions
          : '',
      cancelledReason:
        this.formData.cancelledReason && this.formData.cancelledReason != undefined
          ? this.formData.cancelledReason
          : '',
      completionNote:
        this.formData.completedNote && this.formData.completedNote != undefined
          ? this.formData.completedNote
          : '',
      completeByDate:
        this.formData.completeByDate && this.formData.completeByDate != undefined
          ? this.formData.completeByDate
          : null,
      cancelledDate:
        this.formData.cancelledDate && this.formData.cancelledDate != undefined
          ? this.formData.cancelledDate
          : null,
      sentToVendorDate:
        this.formData.sentToVendorDate && this.formData.sentToVendorDate != undefined
          ? this.formData.sentToVendorDate
          : null,
      completionDate:
        this.formData.completedDate && this.formData.completedDate != undefined
          ? this.formData.completedDate
          : null,
      locationType: this.formData.locationType ? this.formData.locationType : null,
      latitude: $('#formLatitude').text() ? $('#formLatitude').text() : null,
      longitude: $('#formLongitude').text() ? $('#formLongitude').text() : null
    }

    if (this.isDebug == true)
      console.debug(
        'payload=' +
          JSON.stringify(payload) +
          ', address=' +
          JSON.stringify(this.addressFilterQuery)
      )

    if (resetWorkOrder !== undefined && resetWorkOrder) {
      ;(payload.completionDate = null),
        (payload.completionNote = `Reset by board manager as incomplete, on ${today.format(
          'MM-DD-YYYY'
        )}`)
    }

    return payload
  },
  async onFormSubmit(resetWorkOrder) {
    if (!this.formData || this.formData == undefined) {
      notifyError('There was a problem updating your work order.')
      return
    }

    if (this.formData.sentToVendorDate && this.formData.sentToVendorDate != undefined) {
      if (this.formData.sentToVendorDate > today.toDate()) {
        notifyError('The "Sent to Vendor" date cannot be set to a future date.')
        return
      }

      if (this.formData.completedDate !== undefined && this.formData.completedDate) {
        if (this.formData.sentToVendorDate > this.formData.completedDate) {
          notifyError('The "Sent to Vendor" date cannot be set past the completion date.')
          return
        }
      }

      if (this.formData.completeByDate !== undefined && this.formData.completeByDate) {
        if (
          this.formData.sentToVendorDate === today.toDate() &&
          this.formData.sentToVendorDate === this.formData.completedDate
        ) {
          //acceptable
        } else if (this.formData.sentToVendorDate > this.formData.completeByDate) {
          notifyError('The "Sent to Vendor" date cannot be set past the complete by date.')
          return
        }
      }
    }

    try {
      const payload = this.getPayload(resetWorkOrder)
      let validationMessages = ''

      if (!payload.workOrderTypeID || payload.workOrderTypeID == 0) {
        validationMessages = '<div>Please select a valid work order type.</div>'
      }

      if (payload.vendorID == null) {
        validationMessages += '<div>Please select a valid vendor.</div>'
      }

      if (payload.description == null) {
        validationMessages += '<div>Please enter a description.</div>'
      }

      if (validationMessages != '') {
        notifyError(validationMessages)
        return
      }

      await workOrderItem.dispatch('updateWorkOrder', {
        payload: payload,
        done: () => {
          this.reload()
          this.loading = false
        }
      })
    } catch (e) {
      // If this is a validation error, get the details for each field
      if (e instanceof ValidationError) {
        this.$refs.form.setErrors(e.fields)
      }

      notifyError('There was a problem saving the work order.' + e)
    }
    this.loading = false
  },

  getVendorAsyncData: debounce(function(name) {
    // String update
    if (this.name !== name) {
      this.name = name
      this.vendorData = []
    }

    // String cleared
    if (!name.length) {
      this.vendorData = []
      return
    }

    this.isFetching = true
    if (this.isDebug == true) console.debug('this.name=' + this.name)

    if (this.vendorDropDownList) {
      this.vendorData = this.vendorDropDownList.filter(i =>
        i.label.toLowerCase().includes(this.name.toLowerCase())
      )
    }
    this.isFetching = false
  }, 500),

  getVendorMoreAsyncData: debounce(function() {
    this.getVendorAsyncData(this.name)
  }, 250),

  getAsyncData: debounce(function(name) {
    // String update
    if (this.name !== name) {
      this.name = name
      this.addressData = []
    }

    // String cleared
    if (!name.length) {
      this.addressData = []
      return
    }

    this.isFetching = true
    if (this.isDebug == true) console.debug('this.name=' + this.name)

    if (this.addressDropDownList) {
      this.addressData = this.addressDropDownList.filter(i =>
        i.label.toLowerCase().includes(this.name.toLowerCase())
      )
    }
    this.isFetching = false
  }, 500),

  getMoreAsyncData: debounce(function() {
    this.getAsyncData(this.name)
  }, 250)
}
